import * as actions from './actions';
import { tracPageInitialState } from './initial-state';
import { TracPageState } from './state';
import { TracPageActions } from './action-creators';

const tracPageReducer = (
  state: TracPageState = tracPageInitialState,
  action: TracPageActions
): TracPageState => {
  switch (action.type) {
    case actions.UPDATE_TRAC_PAGE_FIELD: {
      if (action.pageType === 'tracpage') {
        return {
          ...state,
          artistPage: {
            ...state.artistPage,
            [action.field]: action.value,
          },
          isArtistPageChanged: true,
        };
      }

      return {
        ...state,
        trackLinks: {
          ...state.trackLinks,
          editor: {
            ...state.trackLinks.editor,
            [action.field]: action.value,
          },
        },
      };
    }

    case actions.UPDATE_TRAC_PAGE_DATA_FIELD: {
      if (action.pageType === 'tracpage') {
        return {
          ...state,
          artistPage: {
            ...state.artistPage,
            data: {
              ...state.artistPage.data,
              [action.field]: action.value,
            },
          },
          isArtistPageChanged: true,
        };
      }

      return {
        ...state,
        trackLinks: {
          ...state.trackLinks,
          editor: {
            ...state.trackLinks.editor,
            data: {
              ...state.trackLinks.editor.data,
              [action.field]: action.value,
            },
          },
        },
      };
    }

    case actions.GET_TRAC_PAGE_SUCCESS: {
      return {
        ...state,
        artistPage: {
          ...action.tracPage,
        },
      };
    }

    case actions.LIST_TRAC_LINKS: {
      return {
        ...state,
        trackLinks: {
          ...state.trackLinks,
          list: [],
        },
      };
    }

    case actions.LIST_TRAC_LINKS_SUCCESS: {
      return {
        ...state,
        trackLinks: {
          ...state.trackLinks,
          list: action.tracLinks,
        },
      };
    }

    case actions.CREATE_TRAC_LINK_SUCCESS: {
      return {
        ...state,
        trackLinks: {
          ...state.trackLinks,
          editor: action.tracLink,
        },
      };
    }

    case actions.DELETE_TRAC_LINK_SUCCESS: {
      return {
        ...state,
        trackLinks: {
          ...state.trackLinks,
          list: state.trackLinks.list.filter((t) => t.id !== action.tracLinkId),
        },
      };
    }

    case actions.SELECT_TRAC_LINK: {
      return {
        ...state,
        trackLinks: {
          ...state.trackLinks,
          editor: {
            ...action.tracLink,
          },
        },
      };
    }
    case actions.SET_ARTIST_PREVIEW: {
      return {
        ...state,
        artistPreview: action.value,
      };
    }
    case actions.UPDATE_TRAC_PAGE_SUCCESS: {
      return {
        ...state,
        isArtistPageChanged: false,
      };
    }

    default:
      return state;
  }
};

export default tracPageReducer;
